export enum ApplicationType {
    AngularDesktop = 1,
    AngularMobile = 2,
    XamarinMobile = 3,
    PWA = 4,
}
